function completeRegistration() {
	if (location.href.toLowerCase().indexOf("completeuserregistration") == -1) {
		return;
	}

	var parameters = getUrlParameters();
	if (!parameters.token) {
		$("#validationError").removeClass("hidden");
		return;
	}
	var formData = "token=" + parameters.token;
	$.ajax({
		url: apiPath + "completeRegistration",
		type: "GET",
		data: formData,
		success: function (data) {
			if (data.message == "success") {
				$("#validationSuccess").removeClass("hidden");
				setTimeout(function () {
					window.location.href = window.location.origin;
				}, 5000);
			} else {
				$("#validationError").removeClass("hidden");
			}
		},
		error: function () {
			$("#validationError").removeClass("hidden");
		},
	});
}
